export default {
	computed: {
		isAppContainer() {
			return window.appcontainer.isiOSAppcontainer;
		},
		isEmployeeAppContainer() {
			return window.appcontainer.isiOSEmployeeApp;
		},
	},
};
